module.exports = __webpack_public_path__ + "img/sec.63ef9057.jpg";